<template>
    <div class="widget" :class="{ 'is-loading': isLoading }">
        <h3>Statistieken</h3>

        <div class="widget__inner">
            <ul class="amounts">
                <li>
                    <p>Projecten</p>
                    <strong>{{ statistics.projects | formatNumber }}</strong>
                </li>

                <li>
                    <p>Objecten</p>
                    <strong>{{ statistics.objects | formatNumber }}</strong>
                </li>

                <li>
                    <p>Opnames</p>
                    <strong>{{ statistics.inspections | formatNumber }}</strong>
                </li>

                <li>
                    <p>Opdrachtgevers</p>
                    <strong>{{ statistics.companies | formatNumber }}</strong>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { FETCH_STATISTICS } from '@/store/modules/widgets'

	export default {
		data () {
			return {
				isLoading: true,
			}
		},

		computed: {
			...mapGetters([
				'statistics',
			]),
		},

		mounted () {
			this.fetchData()
		},

		methods: {
			fetchData () {
				this.$store.dispatch(FETCH_STATISTICS).then(() => {
					this.isLoading = false
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
    .amounts {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 0;
            border-bottom: 1px solid #e6e6e6;

            p {
                margin-bottom: 0;
            }

            strong {
                font-size: 22px;
            }

            &:first-child {
                padding-top: 0;
            }
        }
    }
</style>